var hornstrup = hornstrup || {};
hornstrup.searchOverlay = hornstrup.searchOverlay || function () {
    //share links must have these id's: share-facebook share-twitter share-linkedin
    var self = this;


    this.init = function (callback) {

        $('#search-overlay-trigger-input').on('click',function(){
            if($(this).prop('checked')===true){
                $('#search__input').trigger('focus').val('');
            }
        });

    }

    // public functions:
    return {
        init: init
    };
}();

